import {
  InputNumber as InputNumberPrime,
  InputNumberProps,
} from "primereact/inputnumber";
import styles from "./styles.module.css";

type Props = {
  label?: string;
} & InputNumberProps;

export function InputNumber({ label, ...props }: Props) {
  return (
    <div className="flex flex-column align-items-start">
      {label && (
        <label htmlFor="username" className={styles["input-label"]}>
          {label}
        </label>
      )}
      <InputNumberPrime useGrouping={false} {...props} />
    </div>
  );
}
